export const ProjectsTableColumns = (isArabic) => [
    { id: 'title',      label: isArabic ? 'العنوان'        : 'Title',      align: 'start'  },
    { id: 'slug',       label: isArabic ? 'الرابط (Slug)'  : 'Slug',       align: 'start'  },
    { id: 'client',     label: isArabic ? 'العميل'         : 'Client',     align: 'start'  },
    { id: 'category',   label: isArabic ? 'الفئة'          : 'Category',   align: 'start'  },
    { id: 'status',     label: isArabic ? 'الحالة'         : 'Status',     align: 'center' },
    { id: 'is_featured',label: isArabic ? 'مميز'           : 'Featured',   align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة'  : 'Created At', align: 'start'  },
];